import { Avatar, Menu, MenuItem } from "@mui/material";
import { ReactNode, useCallback, useContext, useMemo, useState } from "react";
import { LogoutOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { WrapperContent } from "../WrapperContent";
import AppContext from "../../context";

interface IMenuItems {
  label: string;
  showDividerBefore: boolean;
  icon: ReactNode;
  link: string;
}

export function Header() {
  const navigate = useNavigate();

  const { fbUser } = useContext(AppContext);

  const [picAnchorEl, setPicAnchorEl] = useState<null | HTMLElement>(null);

  const onToggleProfileMenu = useCallback(() => {
    setPicAnchorEl(null);
  }, []);

  const open = useMemo(() => {
    return Boolean(picAnchorEl);
  }, [picAnchorEl]);

  const menuItems: IMenuItems[] = useMemo(
    () => [
      {
        label: "Cerrar sesión",
        showDividerBefore: true,
        icon: <LogoutOutlined color="secondary" className="!text-lg" />,
        link: "/logout",
      },
    ],
    [],
  );

  const getName: string = useMemo(() => {
    if (fbUser?.email) {
      const splitName = fbUser?.email.split(" ");

      if (splitName.length > 1) {
        return `${fbUser?.email.split(" ")[0][0]}${fbUser?.email.split(" ")[1][0]}`;
      }

      return fbUser?.email.split(" ")[0][0];
    }

    return "";
  }, [fbUser?.email]);

  return (
    <header className="w-full bg-white min-h-16 max-h-16 overflow-hidden flex items-center content-center shadow-header sticky top-0 right-0 z-[19]">
      <WrapperContent>
        <div className="w-full flex items-center content-center justify-end">
          <div className="flex items-center gap-4">
            {fbUser?.email && (
              <span className="font-dmsans text-xs md:text-sm text-secondary no-underline">
                {fbUser.email}
              </span>
            )}

            <div>
              {fbUser?.email && (
                <button
                  type="button"
                  id="avatar-button"
                  className="cursor-pointer py-2 flex items-center"
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    setPicAnchorEl(e.currentTarget);
                  }}
                >
                  <Avatar className="bg-purple-300 uppercase">{getName}</Avatar>
                </button>
              )}

              <Menu
                elevation={1}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                id="profile-menu"
                MenuListProps={{
                  "aria-labelledby": "avatar-button",
                }}
                anchorEl={picAnchorEl}
                open={open}
                onClose={onToggleProfileMenu}
              >
                {menuItems.map((item: IMenuItems) => {
                  return (
                    <div key={`profileNav${item.label}`}>
                      <MenuItem
                        onClick={() => {
                          onToggleProfileMenu();
                          navigate(item.link);
                        }}
                      >
                        {item.icon}
                        <span className="font-dmsans text-sm inline-flex text-secondary ml-2">
                          {item.label}
                        </span>
                      </MenuItem>
                    </div>
                  );
                })}
              </Menu>
            </div>
          </div>
        </div>
      </WrapperContent>
    </header>
  );
}

export default { Header };
